module.exports = __webpack_public_path__ + "33a56d2161c02fd3b83ee39236ee0099.svg";